import { EventsActions } from 'store/actions';
import { EventsSelectors } from 'store/selectors';
import withRouteValidation from 'hocs/withRouteValidation';
import withOrganizationEvents from 'components/organization/withOrganizationEvents';

export default withRouteValidation(
  withOrganizationEvents(
    'organization.pastEvents',
    EventsActions.getPastEvents,
    EventsSelectors.pastEventsState,
    EventsSelectors.pastEventsPagination,
    '-start_at',
    'pastEvents',
  ),
);
